<template lang="pug">
    v-container.white.pa-0.noselect(style="max-width:600px")
        div.mb-9()
            ImageHeader(:header="header")
            ProfileImage(:image="image")
            Profile(:profile="profile")
            Contact.pt-5(:contact="contact")
        v-divider.mx-2
        div.my-9
            h2.text-center Reviews
            Rating(:rating="overallrating")
            div( style="overflow:scroll")
                Review(v-if="reviewIndex < reviews.length" v-for="(n,reviewIndex) in reviewToShow" :key="reviews[reviewIndex].key" :rev="reviews[reviewIndex]")
            div.text-center(v-if="reviewToShow < reviews.length || reviews.length > reviewToShow")
                v-btn.ma-2(style="height:25px" @click="reviewToShow+=2" rounded outlined)
                    h6 Show More ({{reviews.length-reviewToShow}})
            div.text-center(v-if="reviewToShow >= reviews.length")
                v-btn.ma-2(style="height:25px" @click="reviewToShow=2" rounded outlined)
                    h6 Show Less   
        v-divider.mx-2
        div.my-9
            h2.text-center Testimony
            Testimony
        v-divider.mx-2
        div.my-9
            h2.text-center Location
            GMap(:location="location")
        div.my-9.mx-2
            h2.text-center FAQ
            FAQ(:faq="faq")
</template>
<script>
import ImageHeader from '@/components/landingpage/Header.vue'
import ProfileImage from '@/components/landingpage/ProfileImage.vue'
import Profile from '@/components/landingpage/Profile.vue'
import Contact from '@/components/landingpage/Contact.vue'
import Review from '@/components/landingpage/Review.vue'
import Rating from '@/components/landingpage/Rating.vue'
import Testimony from '@/components/landingpage/Testimony.vue'
import GMap from '@/components/landingpage/GoogleMap.vue'
import FAQ from '@/components/landingpage/FAQ.vue'

export default {
    components:{
        ImageHeader,
        ProfileImage,
        Profile,
        Contact,
        Rating,
        Review,
        Testimony,
        GMap,
        FAQ,
    },
    data: () => ({
        header:{
            imgURL:"https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRK5rQEXtKPKkB_EZxBbYheGniWNjo1S86iaQ&usqp=CAU",
            description:"header-image"
        },
        image:{
            imgURL:"https://pbs.twimg.com/profile_images/1321498774024282114/1kj7CAiM_400x400.jpg",
        },
        profile:{
            name:"Hanif Rodili",
            tagline:"Best Seller 2019",
            bio:"Yezza | Fulltime Developer | Degree in Electronic | Universiti Malaysia Boleh",
            location:"Karangan, Kedah",
            description:"Menjual segala benda yang boleh dijual tanpa mengira harga atau kualiti. Barang baik harga baik. Nego sampai jadi."
        },
        contact:{
            phone:"0134714296"
        },
        overallrating:{
            star:4.8,
            reviewcount:7
        },
        reviews:[
            {
                name:"ABC",
                profileimage:"https://via.placeholder.com/96x96?text=ABC",
                date:"01-01-2020",
                rate:3.4,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
            {
                name:"DEF",
                profileimage:"https://via.placeholder.com/96x96?text=DEF",
                date:"02-01-2020",
                rate:4.4,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
            {
                name:"GHI",
                profileimage:"https://via.placeholder.com/96x96?text=GHI",
                date:"01-02-2020",
                rate:4.0,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
            {
                name:"JKL",
                profileimage:"https://via.placeholder.com/96x96?text=JKL",
                date:"03-02-2020",
                rate:3.4,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
            {
                name:"MNO",
                profileimage:"https://via.placeholder.com/96x96?text=MNO",
                date:"04-05-2020",
                rate:4.4,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
            {
                name:"PQR",
                profileimage:"https://via.placeholder.com/96x96?text=PQR",
                date:"20-05-2020",
                rate:4.0,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
            {
                name:"STU",
                profileimage:"https://via.placeholder.com/96x96?text=STU",
                date:"15-06-2020",
                rate:4.0,
                comment:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                images:{
                    1:"https://via.placeholder.com/96x96?text=",
                    2:"https://via.placeholder.com/96x96?text=",
                    3:"https://via.placeholder.com/96x96?text="
                }
            },
        ],
        reviewToShow:2,
        location:{
            lat:2.964292,
            lng:101.719769
        },
        faq:[
            {
                question:"HOW CAN I CHANGE MY SHIPPING ADDRESS?",
                answer:"By default, the last used shipping address will be saved into to your Sample Store account. When you are checking out your order, the default shipping address will be displayed and you have the option to amend it if you need to."
            },
            {
                question:"WHY MUST I MAKE PAYMENT IMMEDIATELY AT CHECKOUT?",
                answer:"Sample ordering is on ‘first-come-first-served’ basis. To ensure that you get your desired samples, it is recommended that you make your payment within 60 minutes of checking out."
            },
            {
                question:"WHAT HAPPENS IN THE EVENT OF WRONG OR MISSING PRODUCTS?",
                answer:"We take such matters very seriously and will look into individual cases thoroughly. Any sample that falls under the below categories should not be thrown away before taking photo proof and emailing the photo of the affected sample and your D.O (Delivery Order) to us at help@mydomain.com (if applicable)."
            },
            {
                question:"HOW DO YOU SHIP MY ORDERS?",
                answer:"All your orders are sent via your selected shipping method."
            },
            {
                question:"WHAT ARE THE PAYMENT METHODS AVAILABLE?",
                answer:"At the moment, we accepnt online payment, bank transfer and cash on delivery."
            }
        ]
    }),
    mounted () {
        this.disablePageZoom()
    },
    methods: {
        disablePageZoom () {
        const tag = document.createElement('meta')
        tag.setAttribute('name','viewport')
        tag.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
        document.head.appendChild(tag)
        },
        skip(){

        }
    }
}
</script>
<style>
    .noselect{
        user-select: none;
    }
</style>